
export default {
  // Hero Section
  heroTitle: "The All-in-one Advertising Platform",
  heroSubtitle: "Reimagined",
  heroDescription: "Scale your brand's impact with precision through automated digital advertising across Saudi Arabia's most influential advertising solutions.",
  startCampaign: "Start a Campaign",
  startAdvertising: "Start Advertising",
  
  // Features
  strategicLocations: "Strategic Locations",
  strategicLocationsDesc: "Place your ads in high-traffic areas for maximum visibility",
  smartTargeting: "Smart Targeting",
  smartTargetingDesc: "Target specific demographics and areas for your campaign",
  programmaticTechnology: "Programmatic Technology",
  programmaticTechnologyDesc: "Leverage cutting-edge technology for optimal ad delivery",
  
  // Features Grid
  whyChooseUs: "Why Choose Us",
  whyChooseUsDesc: "Built for both seasoned advertisers and ambitious ones who demand results, efficiency, and innovation in their campaigns.",
  
  // Value Proposition
  everyAdvertiserDream: "Every Advertiser's Dream",
  everyAdvertiserDreamDesc: "Reach millions with programmatic precision, real-time optimization, and transparent reporting - all from one powerful platform.",
  
  // Stats
  digitalDisplays: "Digital Displays",
  dailyViews: "Daily Views",
  clientSatisfaction: "Client Satisfaction",
  ourImpact: "Our Impact",
  ourImpactDesc: "Trusted by advertisers and marketers who value performance, reach, and measurable results.",
  
  // AI Technology Section
  worldsFirstTech: "World's First Technology",
  revolutionaryAI: "Revolutionary AI Technology for DOOH",
  aiTechDescription: "We've developed groundbreaking artificial intelligence technology specifically for Digital Out-of-Home advertising. This innovative solution is the first of its kind globally, offering unprecedented capabilities in programmatic DOOH optimization. Our AI can create the entire campaign for you - from comprehensive media planning to precise budget calculations - and set it in motion automatically.",
  completeCampaignCreation: "Complete Campaign Creation",
  completeCampaignDesc: "AI automatically generates media plans, calculates budgets, and launches campaigns without manual intervention",
  intelligentAutomation: "Intelligent Automation",
  intelligentAutomationDesc: "From strategy to execution, our AI handles every aspect of campaign deployment and optimization",
  globalInnovation: "Global Innovation",
  globalInnovationDesc: "The world's first AI technology designed exclusively for end-to-end DOOH campaign management",
  newRelease: "🚀 New Release • Complete campaign automation from planning to execution",
  
  // CTA Section
  readyToTransform: "Ready to Transform Your Advertising?",
  readyToTransformDesc: "Join thousands of advertisers and marketers who trust our platform to deliver exceptional results and drive meaningful engagement.",
  createYourCampaign: "Create Your Campaign",
} as const;
